/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'approversEntityUserGroup';

/** API route prefix — shared by `model.js` (createCrudModel) and list descriptor routes. */
export const FETCH_ROUTE = 'globalEntityApproverByUserGroup';

/** Singular entity name for `createCrudModel` reducers/notifications. */
export const ENTITY_NAME = 'approverEntityUserGroup';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'approversEntityUserGroup';

/** Default list sort — matches legacy `useManageApproverEntityUserGroup`. */
export const DEFAULT_ORDER_BY = 'dynamicEntity/displayName asc';
